import script from "./AddItems.vue?vue&type=script&setup=true&lang=js"
export * from "./AddItems.vue?vue&type=script&setup=true&lang=js"

import "./AddItems.vue?vue&type=style&index=0&id=e4e75c5e&lang=scss"

const __exports__ = script;

export default __exports__